<div class="container">
  <div class="text-center mt-4">
    <img id="logo" class="img-fluid" src="images/akvarium_logo.svg">
  </div>
  <div class="mt-5">
    <h3 translate>BILLING.H_CONTACT</h3>
    <div class="mb-2">
      <label for="email" class="form-label" translate>BILLING.L_EMAIL</label>
      <div>
        <input id="email" class="form-control" type="email" [(ngModel)]="email"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
    <div class="form-check form-switch my-3 fs-4">
      <input class="form-check-input" type="checkbox" role="switch" id="give-more-data" [(ngModel)]="giveMoreData">
      <label class="form-check-label" for="give-more-data" translate>BILLING.GIVE_MORE_DATA</label>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="name" class="form-label" translate>BILLING.L_NAME</label>
      <div>
        <input id="name" class="form-control" type="text" [(ngModel)]="name"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="tax-id" class="form-label" translate>BILLING.L_TAX_ID</label>
      <div>
        <input id="tax-id" class="form-control" type="text" [(ngModel)]="taxId"
          aria-invalid="false" aria-required="false">
      </div>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="country" class="form-label" translate>BILLING.L_COUNTRY</label>
      <div>
        <input id="country" class="form-control" type="text" [(ngModel)]="country"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="postal-code" class="form-label" translate>BILLING.L_POSTAL_CODE</label>
      <div>
        <input id="postal-code" class="form-control" type="text" [(ngModel)]="postalCode"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="city" class="form-label" translate>BILLING.L_CITY</label>
      <div>
        <input id="city" class="form-control" type="text" [(ngModel)]="city"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
    <div *ngIf="giveMoreData" class="mb-2">
      <label for="address" class="form-label" translate>BILLING.L_ADDRESS</label>
      <div>
        <input id="address" class="form-control" type="text" [(ngModel)]="address"
          aria-invalid="false" aria-required="true">
      </div>
    </div>
  </div>
  <div class="text-center mt-4 mb-5">
    <button type="button" class="btn btn-dark btn-lg w-75" [disabled]="inProgress || !email"
      (click)="storeCustomerData()">
      <span *ngIf="!inProgress" translate>BILLING.BTN_CONTINUE</span>
      <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
    </button>
  </div>
</div>
